var exports = {
  "ZO": "MessageContextPrefix.module__channelHeader___WTVCSW",
  "wO": "MessageContextPrefix.module__channelHeaderCompact___WTVCSW",
  "p": "MessageContextPrefix.module__channelIcon___WTVCSW",
  "uS": "MessageContextPrefix.module__channelIconAvatar___WTVCSW",
  "bR": "MessageContextPrefix.module__channelIconAvatarImage___WTVCSW",
  "D4": "MessageContextPrefix.module__channelNameButton___WTVCSW",
  "Kw": "MessageContextPrefix.module__channelNameText___WTVCSW",
  "Vf": "MessageContextPrefix.module__channelNamePrimary___WTVCSW",
  "S4": "MessageContextPrefix.module__channelScopeRow___WTVCSW",
  "AQ": "MessageContextPrefix.module__channelScopeGuildIcon___WTVCSW",
  "oN": "MessageContextPrefix.module__channelScopeGuildName___WTVCSW",
  "V$": "MessageContextPrefix.module__channelScopeChevron___WTVCSW",
  "fm": "MessageContextPrefix.module__channelScopeChannelInfo___WTVCSW",
  "Gn": "MessageContextPrefix.module__channelScopeChannelIcon___WTVCSW",
  "wF": "MessageContextPrefix.module__channelScopeChannelName___WTVCSW",
  "bo": "MessageContextPrefix.module__focusRingTight___WTVCSW",
};

module.exports = exports;
